module.exports = __webpack_public_path__ + "static/img/bg8_10.476583f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/bg8_10.jpg
// module id = Rkpx
// module chunks = 3